<template>
  <div>
    <div class="row">
      <div class="col-10">
        <el-button size="small" type="warning" @click="onStart" v-if="!this.legalExpertStatus"><i
            class="fa-solid fa-play"></i> Qəbul
          et və başla</el-button>
        <div v-else>
          <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
            "Hüquqi ekspertiza tərəfindən iş başlanmışdır: " +
            legalExpertStatus.createdBy
            }}</span>
        </div>
      </div>
      <div class="col-2" style="text-align: right">
        <el-dropdown trigger="click" :disabled="act.paymentResult !== 1" @command="handleCommand">
          <el-button type="text" style="padding: 0 !important">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ action: 'approve', id: item.id }"><i
                class="fa-solid fa-square-check"></i>Təsdiqlənməyə
              göndər</el-dropdown-item>
            <el-dropdown-item divided></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <br />
    <!-- <div v-if="this.legalExpertStatus">
      <act-form :value="act"/>
    </div > -->
    <card v-if="this.legalExpertStatus">
      <h4 class="card-title">Akt # {{ act.actNumber }}</h4>
      <el-form :disabled="this.claimStatus >= 151" label-width="200px" :label-position="labelPosition" size="small"
        v-loading="actloading">
        <div class="row">
          <div class="col-md-6 col-12">
            <el-form-item label="Qiymətin əsası" prop="basisPrice">
              <el-input v-model="act.basisPrice"></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6 col-12">
            <el-form-item label="Sığorta ödənişinin məbləği" prop="paymentSumLetter">
              <el-input v-model="act.paymentSumLetter"></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-12">
            <el-form-item label="Reqres / Subroqasiya" prop="subragationStatus">
              <el-select style="width: 100%" :placeholder="$t('Seçin')" size="small" v-model="act.subragationStatus">
                <el-option label="Hadisə / subroqasiya yaranmır" :value="1"></el-option>
                <el-option label="Hadisə / subroqasiya yaranır" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-md-6 col-12">
            <el-form-item label="Ödəniş üzrə qərar" prop="paymentResult">
              <el-select style="width: 100%" :placeholder="$t('Seçin')" size="small" v-model="paymentResult">
                <el-option :label="$t('Təsdiq')" :value="1"></el-option>
                <el-option label="İmtina" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <dir class="col-12">
            <upload :disabled="false" ref="upload" :sourcetype="8" :sourceId="act.id" :autoupload="true"
              :downloadAll="false" listtype="text"></upload>
          </dir>
        </div>
        <div v-show="false">
          <div id="printMe">
            <act-print v-if="actPrint" :value="actPrint" />
          </div>
        </div>

      </el-form>
      <div class="row" style="text-align: right">
        <div class="col-12">
          <el-button type="primary" :disabled="this.claimStatus >= 151"
            @click="onSave">{{$t('Yadda_saxla')}}</el-button>
          <!-- <el-button id="button" type="success" @click="print"><i class="fa-solid fa-print"></i> &nbsp;Çap forması
          </el-button> -->
          <!-- <el-dialog width="78%" top="1vh" :visible.sync="printDialogVisible" center>
            <el-button style="margin-bottom: 10px;" id="button" v-print="'#printMe'" type="success"><i
                class="fa-solid fa-print"></i> &nbsp;Çap et
            </el-button>

            <div id="printMe">
              <act-print v-if="actPrint" :value="this.actPrint" />
            </div>

          </el-dialog> -->
        </div>
      </div>
    </card>

    <el-collapse v-loading="loading" value="1">
      <el-collapse-item name="1">
        <template slot="title">
          <i class="fa-solid fa-copy"></i>
          &nbsp;
          <span>Sənədlər</span>
        </template>
        <div>
          <br>
          <br>
          <claim-docs v-if="item.id" :id="item.id" :readonly="true" />
        </div>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="2">
      <el-collapse-item name="2">
        <template slot="title">
          <i class="fa-solid fa-money-check"></i>
          &nbsp;
          <span>Hesab məlumatları</span>
        </template>
        <div>
          <bank-account-info :value="this.act" :readonly="true" :actPrint="this.actPrint"
            :policyType="item.policyType" />
        </div>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="3">
      <el-collapse-item name="3">
        <template slot="title">
          <i class="fa-solid fa-wrench"></i>
          &nbsp;
          <span>T/E Qiymətləndirməsi</span>
        </template>
        <div>
          <internal-evaluation :value="expertItem" :readonly="true" />
        </div>
        <div>
          <service-evaluation :value="expertItem" :readonly="true" />
        </div>
        <div>
          <service-center-result :value="expertItem" :readonly="true" />
        </div>
        <div>
          <indepentend-evaluation :value="expertItem" :readonly="true" />
        </div>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="4">
      <el-collapse-item name="4">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-headphones-simple"></i>
            &nbsp;
            <span>{{$t('Çağrı_mərkəzinin_qeydləri')}}</span>
          </div>
        </template>
        <div>
          <accident-base :value="accidents"></accident-base>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-loading="loading" value="5">
      <el-collapse-item name="5">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-person-military-pointing"></i>
            &nbsp;
            <span>{{$t('Komissarın_qeydləri')}}</span>
          </div>
        </template>
        <accident-comm-base :value="comm"></accident-comm-base>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="6">
      <el-collapse-item name="6">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-people-arrows-left-right"></i>
            &nbsp;
            <span>{{$t('İştirakçılar')}}</span>
          </div>
        </template>
        <card>
          <el-form v-loading="loading">
            <div class="row" v-for="item in participants" :key="item.id">
              <div class="col-12">
                <participant-card :item="item" :readonly="true" />
              </div>
            </div>
          </el-form>
        </card>
      </el-collapse-item>
    </el-collapse>

    <participant ref="participant" @saved="getParticipants" />
  </div>
</template>

<script>
  import {
    GetAccident,
    GetCommData,
    GetAccidentsByStatus,
    GetParticipants,
  } from "../../services/accident";
  import {
    GetClaim,
    GetClaimTechExpert,
    LegalExperStart,
    UpdateClaimAct,
    GetClaimAct,
    SendToApprove,
    LastClaimStatus
  } from "../../services/claim";
  import { CheckStatusCount } from "src/services/common";
  import { GetClaimActPrint } from "../../services/common";
  import AccidentBase from "../components/AccidentBase.vue";
  import InternalEvaluation from "../components/InternalEvaluation.vue";
  import ServiceEvaluation from "../components/ServiceEvaluation.vue";
  import IndepentendEvaluation from "../components/IndepentendEvaluation.vue";
  import ServiceCenterResult from "../components/ServiceCenterResult.vue";
  import AccidentCommBase from "../components/AccidentCommBase.vue";
  import Participant from "../components/Participant.vue";
  import ParticipantCard from "../components/ParticipantCard.vue";
  import ActPrint from "../components/ActPrint.vue";
  import BankAccountInfo from "../components/BankAccountInfo.vue";
  import Upload from "../components/Upload.vue";
  import ClaimDocs from "../components/ClaimDocs.vue";
  import { DateTimeToString, labelPosition } from "src/services/helper";
  // import ActForm from "../components/ActForm.vue";
  export default {
    props: {
      id: [String, Number],
    },
    components: {
      AccidentBase,
      AccidentCommBase,
      InternalEvaluation,
      ServiceEvaluation,
      IndepentendEvaluation,
      ServiceCenterResult,
      Participant,
      ParticipantCard,
      ActPrint,
      BankAccountInfo,
      Upload,
      ClaimDocs
    },
    data() {
      return {
        loading: false,
        actloading: false,
        commloading: false,
        partloading: false,
        item: {},
        comm: {},
        legalExpertStatus: {},
        participants: [],
        claims: {},
        accidents: {},
        expertData: {},
        expertItem: {},
        act: {},
        actPrint: {},
        paymentResult: null,
        claimStatus: {},
        printDialogVisible: false,
        statusCount: 0,
        uid: this.$store.state.user.id,
        labelPosition: labelPosition,
      };
    },
    methods: {
      getClaimAct() {
        GetClaimAct(this.id).then((response) => {
          this.commloading = false;
          if (response.data.data) {
            this.act = response.data.data;
            this.paymentResult = this.act.paymentResult;

          }
        });
      },
      handleApprove(id) {
        this.checkStatusCount(id, 140).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: "Daha öncə Təsdiqlənməyə göndərilib",
            });
          } else {
            this.$confirm("Təsdiqlənməyə göndərilsin?", "Təsdiqləyin", {
              confirmButtonText: this.$t('Bəli'),
              cancelButtonText: this.$t('Xeyr'),
              type: "info",
            })
              .then(() => {
                this.actloading = true;
                SendToApprove(id, this.uid).then((response) => {
                  this.actloading = false;
                  if (response.data.data) {
                    if (!response.data.isSuccess) {
                      this.$message({
                        type: "error",
                        message: response.data.errors[0],
                      });
                    } else {
                      this.$message({
                        type: "success",
                        message: "Uğurlu əməliyyat",
                      });
                      this.getData();
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: "Səhv əməliyyat",
                    });
                  }
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "info",
                  message: "Xitam verildi",
                });
              });
          }
        });
      },
      checkStatusCount(id) {
        this.statusCount = 0;
        return new Promise((resolve, reject) => {
          CheckStatusCount(0, id, 151).then((response) => {
            if (response.data.data) {
              this.statusCount = response.data.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },
      handleCommand(command) {
        let id = command.id;
        if (command.action === "approve") this.handleApprove(id);
      },

      onSave() {
        this.$confirm("Yadda saxlanılsın?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        })
          .then(() => {
            this.actloading = true;
            this.act.paymentResult = this.paymentResult;
            this.act.commandUserId = this.uid;
            UpdateClaimAct(this.act).then((response) => {
              this.actloading = false;
              if (response.data.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "Yadda saxlanıldı",
                  });
                  this.getData();
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },

      getClaimActPrint() {
        GetClaimActPrint(this.id).then((response) => {
          if (response.data.data) {
            this.actPrint = response.data.data;
          }
        });
      },
      map() {
        this.$refs["mapcontrol"].show(this.comm.lat, this.comm.lng);
      },

      onStart() {
        this.$confirm("Hüquqi ekspertiza üzrə iş başlandı?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.loading = true;
          LegalExperStart(this.id, this.uid).then((response) => {
            this.loading = false;
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Uğurlu əməliyyat",
                });
                this.getData();
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          });
        });
      },
      getCommData() {
        this.commloading = true;
        GetCommData(this.item.accidentId).then((response) => {
          this.commloading = false;
          if (response.data.data) {
            this.comm = response.data.data;
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      getClaimTechExpert() {
        GetClaimTechExpert(this.id).then((response) => {
          this.commloading = false;
          if (response.data.data) {
           this.expertItem = response.data.data?.[0];
          }
        });
      },

      getData() {

        this.loading = true;
        GetClaim(this.id).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.item = response.data.data;
            this.getAccident();
            this.getCommData();
            this.getLegalExpertStatus();
            this.getClaimTechExpert();
            this.getParticipants();
            this.getClaimAct();
            this.getClaimActPrint();
            this.lastClaimStatus();
          } else {
            this.$message({
              type: "warning",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      lastClaimStatus() {
        LastClaimStatus(this.id).then((response) => {
          if (response) {
            this.claimStatus = response.data.data;
          } else {
            this.$message({
              type: "warning",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      getParticipants() {
        this.partloading = true;
        GetParticipants(this.item.accidentId).then((response) => {
          this.partloading = false;
          if (response.data.data) {
            this.participants = response.data.data;
          }
        });
      },
      getAccident() {
        this.commloading = true;
        GetAccident(this.item.accidentId).then((response) => {
          this.commloading = false;
          if (response.data.data) {
            this.accidents = response.data.data;
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      getLegalExpertStatus() {
        this.loading = true;
        GetAccidentsByStatus(0, this.id, 150, this.uid).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.legalExpertStatus = response.data.data;
          } else {
            this.legalExpertStatus = null;
          }
        });
      },
      async print() {
        this.printDialogVisible = true;
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style lang="scss" scoped>

</style>